import { GlobalClient } from 'drupal-jsonapi-client';

import { cacheTTLs } from '../common/constants';

export const configureJsonApiGlobalClient = ({
  baseUrl,
  bypassCache,
  cacheMaxAge,
  sort,
} = {}) => {
  if (baseUrl) {
    GlobalClient.baseUrl = baseUrl;
  } else if (
    typeof window.drupalSettings !== 'undefined' &&
    typeof window.drupalSettings.path !== 'undefined'
  ) {
    GlobalClient.baseUrl = new URL(
      window.drupalSettings.path.baseUrl +
        window.drupalSettings.path.pathPrefix,
      document.baseURI
    ).href;
  }

  GlobalClient.middleware = [];
  GlobalClient.middleware.push(request => {
    if (sort) {
      request.url += `&sort=${sort}`;
    }
    if (bypassCache) {
      request.headers.Pragma = 'no-cache';
      request.headers['Cache-Control'] = 'no-store';
    } else {
      request.cache = {
        maxAge: cacheMaxAge || cacheTTLs.default,
      };
    }
    return request;
  });
};
